import { render, staticRenderFns } from "./ShiftCard.vue?vue&type=template&id=33dc7137&scoped=true&"
import script from "./ShiftCard.vue?vue&type=script&lang=ts&"
export * from "./ShiftCard.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftCard.vue?vue&type=style&index=0&id=33dc7137&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dc7137",
  null
  
)

export default component.exports